import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@artosera/ui';
import { formaterDate } from '../../lib/format.js';
import type { GalerieFiche } from '../../types.js';
import pageStyles from '../../styles/page.module.css';
import { TableauDefilant } from '../../components/TableauDefilant.js';
import tableStyles from '../../styles/table.module.css';
import { RenvoiInvitation } from './RenvoiInvitation.js';

const DROITS = ['voirPrixArtiste', 'coffreConfidentiel', 'emettreFactures', 'publierSite'] as const;

export function MembresTab({ galerie }: { galerie: GalerieFiche }): JSX.Element {
  const { t } = useTranslation('console');

  if (galerie.membres.length === 0) {
    return <p className={pageStyles.videEtat}>{t('fiche.membres.vide')}</p>;
  }

  return (
    <TableauDefilant>
      <table className={tableStyles.table}>
        <thead>
          <tr>
            <th scope="col">{t('fiche.membres.email')}</th>
            <th scope="col">{t('fiche.membres.role')}</th>
            <th scope="col">{t('fiche.membres.droits')}</th>
            <th scope="col">{t('fiche.membres.dernierAcces')}</th>
          </tr>
        </thead>
        <tbody>
          {galerie.membres.map((membre) => (
            <tr key={membre.email}>
              <td>
                <span className={tableStyles.cellulePrincipale}>{membre.email}</span>
                {membre.invitationEnAttente ? (
                  <div className={tableStyles.celluleMuette}>
                    <Badge tone="reserved">{t('invitationDirection.enAttente')}</Badge>{' '}
                    {/* Seule la direction se renvoie d'ici : l'équipe, la galerie l'invite. */}
                    {membre.role === 'direction' ? (
                      <RenvoiInvitation idGalerie={galerie.id} compteId={membre.compteId} />
                    ) : null}
                  </div>
                ) : null}
              </td>
              <td>{membre.role}</td>
              <td>
                {DROITS.some((droit) => membre.droits[droit])
                  ? DROITS.filter((droit) => membre.droits[droit])
                      .map((droit) => t(`fiche.membres.droit.${droit}`))
                      .join(', ')
                  : t('fiche.membres.aucunDroit')}
              </td>

              <td>{formaterDate(membre.dernierAcces, t('fiche.membres.jamaisConnecte'))}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableauDefilant>
  );
}
